export const GET_SELLER = 'GET_SELLER';
export const getSeller = () => ({
  type: GET_SELLER,
});

export const GET_SELLER_SUCCESS = 'GET_SELLER_SUCCESS';
export const getSellerSuccess = (seller, options) => ({
  type: GET_SELLER_SUCCESS,
  seller,
  isInitialLoad: options?.isInitialLoad ?? false,
});

export const GET_SELLER_LIGHT = 'GET_SELLER_LIGHT';
export const getSellerLight = () => ({
  type: GET_SELLER_LIGHT,
});

export const GET_SELLER_LIGHT_SUCCESS = 'GET_SELLER_LIGHT_SUCCESS';
export const getSellerLightSuccess = (seller) => ({
  type: GET_SELLER_LIGHT_SUCCESS,
  seller,
});

export const GET_SELLER_DATA = 'GET_SELLER_DATA';
export const getSellerData = () => ({
  type: GET_SELLER_DATA,
});

export const GET_SELLER_DATA_SUCCESS = 'GET_SELLER_DATA_SUCCESS';
export const getSellerDataSuccess = (data) => ({
  type: GET_SELLER_DATA_SUCCESS,
  data,
});

export const REFRESH_STORE_REQUEST = 'REFRESH_STORE_REQUEST';
export const refreshStore = (storeGuid) => ({
  type: REFRESH_STORE_REQUEST,
  storeGuid,
});

export const REFRESH_STORE_SUCCESS = 'REFRESH_STORE_SUCCESS';
export const refreshStoreSuccess = () => ({
  type: REFRESH_STORE_SUCCESS,
});

export const REFRESH_ALL_STORES_REQUEST = 'REFRESH_ALL_STORES_REQUEST';
export const refreshAllStores = (source) => ({
  type: REFRESH_ALL_STORES_REQUEST,
  source,
});

export const REFRESH_ALL_STORES_SUCCESS = 'REFRESH_ALL_STORES_SUCCESS';
export const refreshAllStoresSuccess = () => ({
  type: REFRESH_ALL_STORES_SUCCESS,
});

export const REFRESH_SELECTED_ORDERS_REQUEST = 'REFRESH_SELECTED_ORDERS_REQUEST';
export const refreshSelectedOrders = (orderIds, storeGuids) => ({
  type: REFRESH_SELECTED_ORDERS_REQUEST,
  orderIds,
  storeGuids,
});

export const REFRESH_SELECTED_ORDERS_SUCCESS = 'REFRESH_SELECTED_ORDERS_SUCCESS';
export const refreshSelectedOrdersSuccess = (results, storeGuids) => ({
  type: REFRESH_SELECTED_ORDERS_SUCCESS,
  results,
  storeGuids,
});

export const REFRESH_SELECTED_ORDERS_ERROR = 'REFRESH_SELECTED_ORDERS_ERROR';
export const refreshSelectedOrdersError = (error, storeGuids) => ({
  type: REFRESH_SELECTED_ORDERS_ERROR,
  error,
  storeGuids,
});

export const GET_STORE_ERROR_LOG = 'GET_STORE_ERROR_LOG';
export const getStoreErrorLogData = (storeId) => ({
  type: GET_STORE_ERROR_LOG,
  storeId,
});

export const GET_STORE_ERROR_LOG_SUCCESS = 'GET_STORE_ERROR_LOG_SUCCESS';
export const getStoreErrorLogSuccess = (data, storeId) => ({
  type: GET_STORE_ERROR_LOG_SUCCESS,
  data,
  storeId,
});

export const GET_STORE_ERROR_LOG_FAILURE = 'GET_STORE_ERROR_LOG_FAILURE';
export const getStoreErrorLogFailure = (error) => ({
  type: GET_STORE_ERROR_LOG_FAILURE,
  error,
});

export const UPDATE_STORE_AFTER_REFRESH = 'UPDATE_STORE_AFTER_REFRESH';
export const updateStoreAfterRefresh = (data) => ({
  type: UPDATE_STORE_AFTER_REFRESH,
  data,
});

export const PRODUCT_IMPORT_NOTIFICATION_REQUESTED = 'PRODUCT_IMPORT_NOTIFICATION_REQUESTED';
export const productImportNotificationRequested = () => ({
  type: PRODUCT_IMPORT_NOTIFICATION_REQUESTED,
});

export const INVENTORY_IMPORT_NOTIFICATION_REQUESTED = 'INVENTORY_IMPORT_NOTIFICATION_REQUESTED';
export const inventoryImportNotificationRequested = () => ({
  type: INVENTORY_IMPORT_NOTIFICATION_REQUESTED,
});

export const GET_SERVICE_MAPPINGS_SUCCESS = 'GET_SERVICE_MAPPINGS_SUCCESS';
export const getServiceMappingsSuccess = (data) => ({
  type: GET_SERVICE_MAPPINGS_SUCCESS,
  data,
});

export const NEW_ORDERS_IMPORTED_FROM_REFRESH = 'NEW_ORDERS_IMPORTED_FROM_REFRESH';
export const newOrdersImportedFromRefresh = () => ({
  type: NEW_ORDERS_IMPORTED_FROM_REFRESH,
});

export const DELETE_SHIP_FROM = 'DELETE_SHIP_FROM';
export const deleteShipFrom = (shipFromId) => ({
  type: DELETE_SHIP_FROM,
  shipFromId,
});

export const ADD_SHIP_FROM = 'ADD_SHIP_FROM';
export const addNewShipFrom = (shipFrom) => ({
  type: ADD_SHIP_FROM,
  shipFrom,
});

export const UPDATE_SELLER_SHIP_FROMS = 'UPDATE_SELLER_SHIP_FROMS';
export const updateSellerShipFroms = (shipFroms) => ({
  type: UPDATE_SELLER_SHIP_FROMS,
  shipFroms,
});

export const EDIT_SHIP_FROM = 'EDIT_SHIP_FROM';
export const editShipFrom = (shipFrom) => ({
  type: EDIT_SHIP_FROM,
  shipFrom,
});

export const REFRESH_LABEL_PROVIDERS_REQUEST = 'REFRESH_LABEL_PROVIDERS_REQUEST';
export const refreshLabelProviders = ({ shouldRefreshServices, sellerLabelProviderId = null }) => ({
  type: REFRESH_LABEL_PROVIDERS_REQUEST,
  shouldRefreshServices: !!shouldRefreshServices,
  sellerLabelProviderId,
});

export const REFRESH_LABEL_PROVDIERS_SUCCESS = 'REFRESH_LABEL_PROVIDERS_SUCCESS';
export const refreshLabelProvidersSuccess = (labelProviders) => ({
  type: REFRESH_LABEL_PROVDIERS_SUCCESS,
  labelProviders,
});

export const REFRESH_LABEL_PROVIDERS_FAILURE = 'REFRESH_LABEL_PROVIDERS_FAILURE';
export const refreshLabelProvidersFailure = (error) => ({
  type: REFRESH_LABEL_PROVIDERS_FAILURE,
  error,
});

export const REFRESH_SELLER_FREIGHT_PROVIDERS_REQUEST = 'REFRESH_SELLER_FREIGHT_PROVIDERS_REQUEST';
export const refreshSellerFreightProvidersRequest = () => ({
  type: REFRESH_SELLER_FREIGHT_PROVIDERS_REQUEST,
});

export const REFRESH_SELLER_FREIGHT_PROVIDERS_SUCCESS = 'REFRESH_SELLER_FREIGHT_PROVIDERS_SUCCESS';
export const refreshSellerFreightProvidersSuccess = (sellerFreightProviders) => ({
  type: REFRESH_SELLER_FREIGHT_PROVIDERS_SUCCESS,
  sellerFreightProviders,
});

export const REFRESH_SELLER_FREIGHT_PROVIDERS_FAILURE = 'REFRESH_SELLER_FREIGHT_PROVIDERS_FAILURE';
export const refreshSellerFreightProvidersFailure = (error) => ({
  type: REFRESH_SELLER_FREIGHT_PROVIDERS_FAILURE,
  error,
});

export const REFRESH_SHIPPING_SERVICES_REQUEST = 'REFRESH_SHIPPING_SERVICES_REQUEST';
export const refreshShippingServicesRequest = () => ({
  type: REFRESH_SHIPPING_SERVICES_REQUEST,
});

export const REFRESH_SHIPPING_SERVICES_SUCCESS = 'REFRESH_SHIPPING_SERVICES_SUCCESS';
export const refreshShippingServicesSuccess = (services) => ({
  type: REFRESH_SHIPPING_SERVICES_SUCCESS,
  services,
});

export const REFRESH_SERVICE_COLLECTIONS_SUCCESS = 'REFRESH_SERVICE_COLLECTIONS_SUCCESS';
/**
 * @typedef {import('../../prop-types/service-collection').ServiceCollection} ServiceCollection
 * @param {ServiceCollection[]} serviceCollections
 * @returns {{ type: string, serviceCollections: ServiceCollection[] }}
 */
export const refreshServiceCollectionsSuccess = (serviceCollections) => ({
  type: REFRESH_SERVICE_COLLECTIONS_SUCCESS,
  serviceCollections,
});

export const REFRESH_SHIPPING_SERVICES_FAILURE = 'REFRESH_SHIPPING_SERVICES_FAILURE';
export const refreshShippingServicesFailure = (error) => ({
  type: REFRESH_SHIPPING_SERVICES_FAILURE,
  error,
});

export const REFRESH_SERVICE_LEVELS_REQUEST = 'REFRESH_SERVICE_LEVELS_REQUEST';
export const refreshServiceLevelsRequest = () => ({
  type: REFRESH_SERVICE_LEVELS_REQUEST,
});

export const REFRESH_PACKAGES_REQUEST = 'REFRESH_PACKAGES_REQUEST';
export const refreshPackagesRequest = () => ({
  type: REFRESH_PACKAGES_REQUEST,
});

export const REFRESH_PACKAGES_SUCCESS = 'REFRESH_PACKAGES_SUCCESS';
export const refreshPackagesSuccess = (packages) => ({
  type: REFRESH_PACKAGES_SUCCESS,
  packages,
});

export const REFRESH_PACKAGES_FAILURE = 'REFRESH_PACKAGES_FAILURE';
export const refreshPackagesFailure = (error) => ({
  type: REFRESH_PACKAGES_FAILURE,
  error,
});

export const PROMPT_SHIPSTATION_DHL_TERMS_AND_CONDITIONS = 'PROMPT_SHIPSTATION_DHL_TERMS_AND_CONDITIONS';
export const promptShipstationDHLTermsAndConditions = (postAcceptanceAction) => ({
  type: PROMPT_SHIPSTATION_DHL_TERMS_AND_CONDITIONS,
  postAcceptanceAction,
});

export const ACCEPT_DHL_WALLET_TERMS_REQUEST = 'ACCEPT_DHL_WALLET_TERMS_REQUEST';
export const acceptDhlWalletTermsRequest = () => ({
  type: ACCEPT_DHL_WALLET_TERMS_REQUEST,
});

export const ACCEPT_DHL_WALLET_TERMS_SUCCESS = 'ACCEPT_DHL_WALLET_TERMS_SUCCESS';
export const acceptDhlWalletTermsSuccess = () => ({
  type: ACCEPT_DHL_WALLET_TERMS_SUCCESS,
});

export const ACCEPT_DHL_WALLET_TERMS_FAILURE = 'ACCEPT_DHL_WALLET_TERMS_FAILURE';
export const acceptDhlWalletTermsFailure = () => ({
  type: ACCEPT_DHL_WALLET_TERMS_FAILURE,
});

export const STAMPS_ACCOUNT_VERIFICATION = 'STAMPS_ACCOUNT_VERIFICATION';
export const startStampsAccountVerification = (data) => ({
  type: STAMPS_ACCOUNT_VERIFICATION,
  data,
});

export const CLEAR_OUT_SERVICE_MAPPINGS = 'CLEAR_OUT_SERVICE_MAPPINGS';
export const clearOutServiceMappings = () => ({
  type: CLEAR_OUT_SERVICE_MAPPINGS,
});

export const SAVE_NEW_SELLER_SETTINGS = 'SAVE_NEW_SELLER_SETTINGS';
export const saveNewSellerSettings = (newSellerSettings) => ({
  type: SAVE_NEW_SELLER_SETTINGS,
  newSellerSettings,
});

export const UPDATE_SELLER_TIMEZONE = 'UPDATE_SELLER_TIMEZONE';
export const updateSellerTimeZone = (timeZone) => ({
  type: UPDATE_SELLER_TIMEZONE,
  timeZone,
});

export const UPDATE_SELLER_PHONE = 'UPDATE_SELLER_PHONE';
export const updateSellerPhone = (phone) => ({
  type: UPDATE_SELLER_PHONE,
  phone,
});

export const UPDATE_SHIPSURANCE_BALANCE = 'UPDATE_SHIPSURANCE_BALANCE';
export const updateShipsuranceBalance = (value) => ({
  type: UPDATE_SHIPSURANCE_BALANCE,
  value,
});

export const SELLER_PROVIDERS_UPDATED = 'SELLER_PROVIDERS_UPDATED';
export const sellerProvidersUpdated = () => ({
  type: SELLER_PROVIDERS_UPDATED,
});

export const REFRESH_SELLER_WALLETS = 'REFRESH_SELLER_WALLETS';
export const refreshSellerWallets = () => ({
  type: REFRESH_SELLER_WALLETS,
});

export const REFRESH_SELLER_WALLETS_FAILURE = 'REFRESH_SELLER_WALLETS_FAILURE';
export const refreshSellerWalletsFailure = () => ({
  type: REFRESH_SELLER_WALLETS_FAILURE,
});

export const UPDATE_SELLER_WALLETS = 'UPDATE_SELLER_WALLETS';
export const updateSellerWallets = (wallets) => ({
  type: UPDATE_SELLER_WALLETS,
  wallets,
});

export const REFRESH_STORE_LIST = 'REFRESH_STORE_LIST';
export const refreshStoreList = () => ({
  type: REFRESH_STORE_LIST,
});

export const REFRESH_STORE_LIST_SUCCESS = 'REFRESH_STORE_LIST_SUCCESS';
export const refreshStoreListSuccess = (data) => ({
  type: REFRESH_STORE_LIST_SUCCESS,
  data,
});

export const UPDATE_SELLER_INVENTORY_WAREHOUSES = 'UPDATE_SELLER_INVENTORY_WAREHOUSES';
export const updateSellerInventoryWarehouses = (inventoryWarehouses) => ({
  type: UPDATE_SELLER_INVENTORY_WAREHOUSES,
  inventoryWarehouses,
});

export const UPDATE_SELLER_INVENTORY_WAREHOUSES_LOCATIONS = 'UPDATE_SELLER_INVENTORY_WAREHOUSES_LOCATIONS';
export const updateSellerInventoryWarehousesLocations = (inventoryWarehousesLocations) => ({
  type: UPDATE_SELLER_INVENTORY_WAREHOUSES_LOCATIONS,
  inventoryWarehousesLocations,
});

export const UPDATE_SELLER_TOTES = 'UPDATE_SELLER_TOTES';
export const updateSellerTotes = (totes) => ({
  type: UPDATE_SELLER_TOTES,
  totes,
});

export const GET_SELLER_TOTES_REQUEST = 'GET_SELLER_TOTES_REQUEST';
export const getSellerTotesRequest = () => ({
  type: GET_SELLER_TOTES_REQUEST,
});

export const SET_SELLER_TOTES_ERROR = 'SET_SELLER_TOTES_ERROR';
export const setSellerTotesError = (error) => ({
  type: SET_SELLER_TOTES_ERROR,
  error,
});

export const UPDATE_SHIPPERHQ_CONNECTED_STORES = 'UPDATE_SHIPPERHQ_CONNECTED_STORES';
export const updateShipperHQConnectedStores = (storeGuids) => ({
  type: UPDATE_SHIPPERHQ_CONNECTED_STORES,
  storeGuids,
});

export const REFRESH_PACKING_SLIP_TEMPLATES = 'REFRESH_PACKING_SLIP_TEMPLATES';
export const refreshPackingSlipTemplates = () => ({
  type: REFRESH_PACKING_SLIP_TEMPLATES,
});

export const REFRESH_PACKING_SLIP_TEMPLATES_SUCCESS = 'REFRESH_PACKING_SLIP_TEMPLATES_SUCCESS';
export const refreshPackingSlipTemplatesSuccess = (data) => ({
  type: REFRESH_PACKING_SLIP_TEMPLATES_SUCCESS,
  data,
});

export const REFRESH_DELIVERY_EMAIL_TEMPLATES = 'REFRESH_DELIVERY_EMAIL_TEMPLATES';
export const refreshDeliveryEmailTemplates = () => ({
  type: REFRESH_DELIVERY_EMAIL_TEMPLATES,
});

export const REFRESH_DELIVERY_EMAIL_TEMPLATES_SUCCESS = 'REFRESH_DELIVERY_EMAIL_TEMPLATES_SUCCESS';
export const refreshDeliveryEmailTemplatesSuccess = (data) => ({
  type: REFRESH_DELIVERY_EMAIL_TEMPLATES_SUCCESS,
  data,
});

export const REFRESH_SHIPMENT_EMAIL_TEMPLATES = 'REFRESH_SHIPMENT_EMAIL_TEMPLATES';
export const refreshShipmentEmailTemplates = () => ({
  type: REFRESH_SHIPMENT_EMAIL_TEMPLATES,
});

export const REFRESH_SHIPMENT_EMAIL_TEMPLATES_SUCCESS = 'REFRESH_SHIPMENT_EMAIL_TEMPLATES_SUCCESS';
export const refreshShipmentEmailTemplatesSuccess = (data) => ({
  type: REFRESH_SHIPMENT_EMAIL_TEMPLATES_SUCCESS,
  data,
});

export const REFRESH_SELLER_DATA_BY_PROPERTY_NAME = 'REFRESH_SELLER_DATA_BY_PROPERTY_NAME';
export const refreshSellerDataByProperty = (propertyName, data) => ({
  type: REFRESH_SELLER_DATA_BY_PROPERTY_NAME,
  data,
  propertyName,
});

export const SELLER_SUBSCRIPTION_PLAN_INFO_UPDATED = 'SELLER_SUBSCRIPTION_PLAN_INFO_UPDATED';
export const sellerSubscriptionPlanInfoUpdated = () => ({
  type: SELLER_SUBSCRIPTION_PLAN_INFO_UPDATED,
});

export const UPDATE_SELLER_PLAN_INFO = 'UPDATE_SELLER_PLAN_INFO';
export const updateSellerPlanInfo = (planInfo) => ({
  type: UPDATE_SELLER_PLAN_INFO,
  planInfo,
});

export const UPDATE_SELLER_SUBSCRIPTION_DATA = 'UPDATE_SELLER_SUBSCRIPTION_DATA';
export const updateSellerSubscriptionData = (subscriptionData) => ({
  type: UPDATE_SELLER_SUBSCRIPTION_DATA,
  subscriptionData,
});

export const REFRESH_PLAN_AND_SUBSCRIPTION_INFO = 'REFRESH_PLAN_AND_SUBSCRIPTION_INFO';
export const refreshSellerPlanAndSubscriptionInfo = () => ({
  type: REFRESH_PLAN_AND_SUBSCRIPTION_INFO,
});

// hack: this is simply for testing and can be removed at any time
export const UPDATE_HAS_CREATED_LABEL = 'UPDATE_HAS_CREATED_LABEL';
export const updateHasCreatedLabel = (hasCreatedLabel) => ({
  type: UPDATE_HAS_CREATED_LABEL,
  hasCreatedLabel,
});

export const UPDATE_BUY_NOW_SETTING = 'UPDATE_BUY_NOW_SETTING';
export const updateBuyNowSetting = (setting) => ({
  type: UPDATE_BUY_NOW_SETTING,
  setting,
});
